
export default function PricingComparison() {
  return (
    <section id="pricing" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            購入とリースとの比較
          </h2>
          <p className="text-xl text-gray-600">
            スリホなら、圧倒的なコストパフォーマンスを実現
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden mb-16">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-blue-600 to-blue-500">
                  <th className="px-6 py-5 text-left text-white font-bold text-lg">項目</th>
                  <th className="px-6 py-5 text-center text-white font-bold text-lg bg-blue-700">スリホの場合</th>
                  <th className="px-6 py-5 text-center text-white font-bold text-lg">リースの場合</th>
                  <th className="px-6 py-5 text-center text-white font-bold text-lg">購入の場合</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200 hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-5 font-semibold text-gray-900">初期費用</td>
                  <td className="px-6 py-5 text-center bg-blue-50">
                    <span className="text-2xl font-bold text-blue-600">0円</span>
                  </td>
                  <td className="px-6 py-5 text-center text-gray-700">0円</td>
                  <td className="px-6 py-5 text-center text-gray-700">10,000円</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-5 font-semibold text-gray-900">インク代</td>
                  <td className="px-6 py-5 text-center bg-blue-50">
                    <span className="text-2xl font-bold text-blue-600">0円</span>
                  </td>
                  <td className="px-6 py-5 text-center text-gray-700">0円</td>
                  <td className="px-6 py-5 text-center text-gray-700">10,000円</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-5 font-semibold text-gray-900">リース料金</td>
                  <td className="px-6 py-5 text-center bg-blue-50">
                    <span className="text-2xl font-bold text-blue-600">0円</span>
                  </td>
                  <td className="px-6 py-5 text-center text-gray-700">5,000円</td>
                  <td className="px-6 py-5 text-center text-gray-700">0円</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-5 font-semibold text-gray-900">メンテナンス料金</td>
                  <td className="px-6 py-5 text-center bg-blue-50">
                    <span className="text-2xl font-bold text-blue-600">0円</span>
                  </td>
                  <td className="px-6 py-5 text-center text-gray-700">0円</td>
                  <td className="px-6 py-5 text-center text-gray-700">8,000円</td>
                </tr>
                <tr className="border-b border-gray-200 hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-5 font-semibold text-gray-900">カウンター</td>
                  <td className="px-6 py-5 text-center bg-blue-50">
                    <span className="text-2xl font-bold text-blue-600">0円</span>
                  </td>
                  <td className="px-6 py-5 text-center text-gray-700">20,000円</td>
                  <td className="px-6 py-5 text-center text-gray-700">0円</td>
                </tr>
                <tr className="bg-gradient-to-r from-blue-50 to-blue-100">
                  <td className="px-6 py-6 font-bold text-gray-900 text-lg">月額総金額</td>
                  <td className="px-6 py-6 text-center">
                    <div className="text-sm text-blue-700 font-semibold mb-1">会社負担</div>
                    <div className="text-3xl font-bold text-blue-600">8,000円</div>
                  </td>
                  <td className="px-6 py-6 text-center">
                    <div className="text-3xl font-bold text-gray-900">33,000円</div>
                  </td>
                  <td className="px-6 py-6 text-center">
                    <div className="text-3xl font-bold text-gray-900">18,000円</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Note */}
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg">
          <p className="text-sm text-gray-700 leading-relaxed">
            ※このシミュレーションは一例です。実際の料金は印刷枚数や機種により異なります。詳しくはお問い合わせください。<br />
            ※ご利用状況により、料金が変動する場合がございます。詳細はお気軽にご相談ください。
          </p>
        </div>
      </div>
    </section>
  );
}
